<script lang="ts">
  import '../app.css';
  import { onMount, type Snippet } from 'svelte';
  import { page } from '$app/state';
  import Layout from '$lib/components/Layout.svelte';
  import type { ApiIdentity } from '$lib/api/types';
  import { platformLimits } from '$lib/state/limits.svelte';

  let { data, children } = $props<{
    data: { identityPromise: Promise<ApiIdentity | null> };
    children: Snippet;
  }>();

  // The layout chrome renders immediately regardless of identity state, so
  // users see structure instantly even on a deep-link cold load that hasn't
  // yet confirmed their session. Re-auth is centralized: the identity fetch
  // (like every API call) goes through the API client, which redirects the
  // whole window to login on a 401 — so an unauthenticated visitor is bounced
  // without this component doing anything. A network failure (not a 401)
  // deliberately does NOT redirect; the page surfaces its own retry affordance.
  onMount(async () => {
    let me: ApiIdentity | null = null;
    try {
      me = await data.identityPromise;
    } catch {
      me = null;
    }
    if (me) {
      // Pull platform caps once we know the user is signed in. refresh()
      // is dedup'd + TTL-gated so calling it more than once is cheap.
      void platformLimits.refresh();
    }
  });
</script>

{#if page.url.pathname.startsWith('/auth/')}
  {@render children()}
{:else}
  <Layout>{@render children()}</Layout>
{/if}
